import React from 'react'
import { Modal, StyleSheet, View, Text, Pressable } from 'react-native'
import Colors from '../constants/Colors'
import { analysisDisabled } from '../constants/Config'

export interface IConfirmationModalProps {
  isVisible: boolean
  setVisible: (arg0: boolean) => void
  onSubmit: () => void
  text: string
  cancelText?: string
  submitText?: string
  title?: string
}

const styles = StyleSheet.create({
  centeredView: {
    paddingHorizontal: 20,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    padding: 20,
    backgroundColor: 'white',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalText: {
    marginBottom: 10,
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
    alignContent: 'center',
    color: Colors.oxfordBlue,
    fontFamily: 'Roboto_400Regular',
    fontSize: 15,
    marginBottom: 20,
    lineHeight: 30,
  },
  buttonView: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  buttonTextCancel: {
    color: Colors.oxfordBlue,
    fontFamily: 'Roboto_400Regular',
    fontSize: 13,
  },
  buttonTextContinue: {
    color: analysisDisabled ? Colors.oxfordBlue : Colors.white,
    fontFamily: 'Roboto_400Regular',
    fontSize: 13,
  },
  buttonCancel: {
    marginLeft: 5,
    padding: 10,
    width: 'fit-content',
    alignItems: 'center',
  },
  buttonContinue: {
    marginLeft: 10,
    padding: 5,
    paddingHorizontal: 15,
    width: 'fit-content',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: analysisDisabled ? Colors.orangeWeb : Colors.oxfordBlue,
    borderRadius: 5,
  },
  title: {
    textAlign: 'center',
    fontWeight: '600',
    lineHeight: 26,
    fontSize: 20,
    marginBottom: 20,
  },
})

export default function ConfirmationModalModal({
  isVisible,
  setVisible,
  onSubmit,
  text,
  cancelText = 'Mégse',
  submitText = 'Tovább',
  title,
}: IConfirmationModalProps) {
  return (
    <View style={styles.centeredView}>
      <Modal
        animationType="none"
        transparent={true}
        visible={isVisible}
        onRequestClose={() => {
          setVisible(!isVisible)
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            {title ? <Text style={styles.title}>{title}</Text> : null}
            <Text style={styles.text}>{text}</Text>
            <View style={styles.buttonView}>
              <Pressable
                style={styles.buttonCancel}
                onPress={() => setVisible(false)}
              >
                <Text style={styles.buttonTextCancel}>{cancelText}</Text>
              </Pressable>
              <Pressable
                style={styles.buttonContinue}
                onPress={() => {
                  setVisible(false)
                  onSubmit()
                }}
              >
                <Text style={styles.buttonTextContinue}>{submitText}</Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  )
}
